import { __assign } from "tslib";
import { createStructureAndContentApi, structureAndContentRelativePath } from './';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
import { createHttpTestKit } from '../../../http/test-kit';
export var createStructureAndContentApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createStructureAndContentApi('', fakeHttp);
    var testKit = {
        whenGet: function (dto) {
            var url = structureAndContentRelativePath(dto.locale, dto.brandId);
            return createFakeGetResponder(fakeHttp, url);
        },
        whenUpdatePageAndSidebar: function (dto) {
            var url = "".concat(structureAndContentRelativePath(dto.locale), "/pageAndSidebar").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : '');
            return createFakePutResponder(fakeHttp, url)(dto);
        },
        whenUpdateHeader: function (dto) {
            var url = "".concat(structureAndContentRelativePath(dto.locale), "/header").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : '');
            return createFakePutResponder(fakeHttp, url)(dto);
        },
        whenUpdateFooter: function (dto) {
            var url = "".concat(structureAndContentRelativePath(dto.locale), "/footer").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : '');
            return createFakePutResponder(fakeHttp, url)(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map